<template>
  <div class='EnbItemView01'>
    <div class="EnbItem">
      <div class="cont-imgs">
        <div class="sold-out" v-if="ItemSelected01.gerEstoque && ItemSelected01.estoque <= 0 && ItemSelected01.tipo !== 'Variável'">Esgotado</div>
        <carousel
        :items-to-show="1"
        v-if="ItemSelected01.img.length"
        v-model="currentSlide"
        >
          <slide v-for="(img, key) in ItemSelected01.img.map(i => api + i.img)" :key="key">
            <div class="c-img">
            <vue-image-zoomer
            :regular="img"
            hover-message="⚲ Zoom"
            img-width="300"
            img-height="300"
            />
            </div>
          </slide>
          <template #addons>
            <navigation />
          </template>
        </carousel>
        <img-icon
        v-if="!ItemSelected01.img.length"
        :options="{ width: '180px', height: '150px', color: '#CCCCCC', action: false }"
        />
        <Carousel
        v-if="ItemSelected01.img.length"
        :items-to-show="7"
        v-model="currentSlide"
        ref="carousel"
        >
          <Slide v-for="(img, key) in ItemSelected01.img.map(i => api + i.img)" :key="key">
            <div class="cont-pag" @click="slideTo(key)">
              <img class="img-pagination" :src="img">
            </div>
          </Slide>
          <template #addons>
            <pagination paginateByItemsToShow="true"/>
          </template>
        </Carousel>
      </div>
      <div class="cont">
        <div class="cont-desc name">
          {{ ItemSelected01.name }}
        </div>
        <div class="cont-desc desc" :style="{ color: Prefes.lojaCorFonte.color }">
          {{ ItemSelected01.descricao }}
        </div>
        <select-prop
        v-for="(data, k) in ItemSelected01.atributos"
        :key="k"
        :data="data"
        :estoqueVariavel="ItemSelected01.estoqueVariavel"
        />
        <div class="cont-desc valor">
          <span :class="{ disabled: ItemSelected01.oferta > 0 }" style="margin: 5px">{{ ItemSelected01.preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</span>
          <span v-if="ItemSelected01.oferta > 0" style="margin: 5px">{{ ItemSelected01.oferta.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</span>
        </div>
        <div class="qtda-btn">
          <div class="qtda">
            <enb-setQtda01 @update:qtda="newValue => qtda = newValue"/>
          </div>
          <div class="btn">
            <button
            @click="push"
            :disabled="ItemSelected01.gerEstoque && ItemSelected01.estoque <= 0 && ItemSelected01.tipo !== 'Variável'"
            :style="{ 
              backgroundColor: Prefes.btnProduto.corBackground,
              fontFamily: Prefes.btnProduto.font,
              color: Prefes.btnProduto.corFont
            }"
            >
              Comprar
            </button>
          </div>
        </div>
        <div class="cont-code">
          Código: {{ ItemSelected01.code }}
        </div>
        <div class="cont-btn-like">
          <btn-like :data="ItemSelected01"/>
        </div>
      </div>
    </div>
    <enb-suggestion/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { VueImageZoomer } from 'vue-image-zoomer'
import 'vue-image-zoomer/dist/style.css'
import EnbSetQtda01 from './EnbSetQtda01.vue'
import { Carousel, Slide, Navigation, Pagination } from 'vue3-carousel'
import 'vue3-carousel/dist/carousel.css'
import SelectProp from './SelectProp'
import ImgIcon from '@/components/EnbPainel/Icons/ImgIcon'
import EnbSuggestion from './EnbSuggestion'
import BtnLike from '../../Like/BtnLike'
import api from '@/mixins/api'
import meta, { produtoMeta } from '@/mixins/meta'
export default {
  name: 'EnbItemView01',
  components: { VueImageZoomer, EnbSetQtda01, Carousel, Slide, Navigation, Pagination, SelectProp, ImgIcon, EnbSuggestion, BtnLike },
  computed: {
    ...mapGetters(['ItemSelected01', 'Prefes', 'Empresa']),
    metaPage () {
      let p = this.ItemSelected01
      let link = this.$route.params.link
      if(!p || !p.name || (link && p.link !== link)) return null
      return produtoMeta(this.Empresa, p)
    }
  },
  mixins: [api, meta],
  data () {
    return {
      qtda: 1,
      currentSlide: 0
    }
  },
  methods: {
    ...mapActions(['PushCheckout01', 'ToggleCheckout01', 'GetProductId', 'PushMsg', '_UpdateProductVisualization']),
    push () {
      let atributosValues = this.ItemSelected01.atributos.map(a => {
        if(a.values.filter(v => v.selected).length) {
          return { name: a.name, selected: true }
        }
        else {
          return { name: a.name, selected: false }
        }
      })
      if(atributosValues.filter(a => !a.selected).length) {
        let variacoes = ''
        let atributosNaoSelecionados = atributosValues.filter(a => !a.selected)
        for(let key in atributosNaoSelecionados) {
          if(parseInt(key) === (atributosNaoSelecionados.length - 1)) {
            variacoes = variacoes + atributosNaoSelecionados[key].name
          }
          else {
            variacoes = variacoes + atributosNaoSelecionados[key].name + ', '
          }
        }
        this.PushMsg({ msg: `Selecione: ${variacoes}`, color: 'orange' })
        return
      }
      this.PushCheckout01({ item: this.ItemSelected01, qtda: parseInt(this.qtda) })
      this.ToggleCheckout01(true)
    },
    slideTo(val) {
      this.currentSlide = val
    }
  }
  ,
  async beforeMount () {
    if(typeof this.$route.params.link !== 'undefined') {
      await this.GetProductId(this.$route.params.link)
    }
  },
  created () {
    this._UpdateProductVisualization(this.ItemSelected01.id)
  }
}
</script>

<style scoped>
.EnbItem {
  display: flex;
  justify-content: center;
  padding-top: 2%;
}

.c-img {
  width: 295px;
  height: 295px;
  border-radius: 5px;
  overflow: hidden;
  background-color: green;
}

.cont-imgs {
  width: 40%;
}

.cont {
  width: 30%;
  padding: 2%;
}

.cont-desc {
  text-align: left;
  font-size: 22px;
  padding: 1%;
}

.name {
  font-weight: bold;
}

.desc {
  font-size: 18px;
  color: #333333;
}

.valor {
  font-weight: bold;
  padding-top: 5%;
}

.qtda-btn {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 2%;
}

.qtda {
  width: 50%;
}

.btn {
  width: 50%;
}

button {
  width: 70%;
  padding: 4.5%;
  border: 0;
  border-radius: 10px;
  background-color: #4E7826;
  color: #FFFFFF;
  cursor: pointer;
}

.cont-code {
  padding: 2%;
  text-align: left;
  padding-left: 0;
}

.disabled {
  color: #CCCCCC;
  text-decoration: line-through;
}

.cont-pag {
  width: 50px;
  height: 50px;
  /* border: thin solid #CCCCCC; */
}

.img-pagination {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}

.sold-out {
  width: max-content;
  font-size: 10px;
  color: #FFFFFF;
  padding: 5px;
  background-color: red;
  border-radius: 5px;
  /* border: 2px solid #FFFFFF; */
  margin: auto;
}

button:disabled {
  opacity: 0.50;
}

@media (max-width: 500px) {
  .EnbItem {
    display: block;
  }
  .cont-imgs {
    width: 100%;
  }
  .cont {
    width: 100%;
  }
  .cont-desc {
    text-align: center;
  }
}
</style>
